module.exports = __webpack_public_path__ + "media/shakealert_alert2_x4.wav";